module.exports = __webpack_public_path__ + "img/38d797f.png";